import { connect } from '@/common/lib/riot-redux';
import { showAction, hideAction } from './action';

import KfTooltip from './kf-tooltip.riot';

const mapStateToProps = (state, props) => {

  return props;
};

const mapDispatchToProps = (dispatch) => ({
  show(payload) {
    dispatch(showAction(payload));
  },
  hide(payload) {
    dispatch(hideAction(payload));
  },
});

export default connect(KfTooltip, mapStateToProps, mapDispatchToProps);